import { Helmet } from 'react-helmet-async';
import { Typography, Container, Box, Card } from '@mui/material';
import { CenterContent } from '../utils/LayoutStyles';
/**
 * @returns 404 error page UI
 */
export default function Maintenance() {
  return (
    <>
      <Helmet>
        <title>Manutenzione in corso</title>
      </Helmet>

      <Container className="default-bg" sx={{ height: '100%', width: '100%', maxWidth: 'unset !important' }}>
        <CenterContent>
          <Card sx={{ padding: '24px' }}>
            <Typography variant="h3" paragraph>
              Manutenzione in corso!
            </Typography>

            <Typography sx={{ color: 'text.secondary' }}>
              Il portale HUB è attualmente in manutenzione, torneremo operativi al più presto!
            </Typography>

            <Box component="img" src="/assets/images/img/wip.png" />
          </Card>
        </CenterContent>
      </Container>
    </>
  );
}
